export default __webpack_public_path__ + "static/media/ic_con_mail.54adfa82.svg";